import * as Yup from "yup";
import { parseMaskedDollarInput } from "@/core/utils/money";

export const payoutInitialValues = {
  amount: "",
  confirm_payout: false,
  final_payout: false,
  notes: "",
  customer_message: "",
  deal_size: "",
};

export type PayoutFormValues = typeof payoutInitialValues;

export const createPayoutSchema = (requiresDealSize: boolean) => {
  const baseSchema = {
    amount: Yup.string()
      .required("Amount is required")
      .test("min-value", "Amount must be at least 1", (value) => {
        if (!value) return false;
        const num = parseMaskedDollarInput(value);
        return num !== null && num >= 1;
      }),
    confirm_payout: Yup.boolean()
      .required("You must confirm the payout")
      .oneOf([true], "You must confirm the payout"),
    notes: Yup.string().optional(),
    customer_message: Yup.string().optional(),
  };

  if (requiresDealSize) {
    return Yup.object().shape({
      ...baseSchema,
      deal_size: Yup.string()
        .required("Deal size is required")
        .test("valid-amount", "Deal size must be a valid amount", (value) => {
          if (!value) return false;
          const num = parseMaskedDollarInput(value);
          return num !== null && num > 0;
        }),
    });
  }

  return Yup.object().shape(baseSchema);
};
